import { render, staticRenderFns } from "./groupCompanyDetails.vue?vue&type=template&id=7296af03&"
import script from "./groupCompanyDetails.vue?vue&type=script&lang=js&"
export * from "./groupCompanyDetails.vue?vue&type=script&lang=js&"
import style0 from "./groupCompanyDetails.vue?vue&type=style&index=0&id=7296af03&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports